import { replaceTextWithValues } from 'src/common/utils/text-replace';
import get from 'lodash/get';

export const isMarketingCard = item => (
  get(item, 'product.main.documentType', null) === 'marketing_card'
);

export const addMarketingCardCode = (card => {
  if (!card.title.includes('%{code}')) {
    return {};
  }

  const style = `background-color: ${card.codeBackgroundColor}; color: ${card.codeTextColor};`;

  const title = replaceTextWithValues(card.title, {
    code: `<span class="promo-code" style="${style}">${card.code}</span>`
  });

  return {
    promoCodeTitle: [{ text: title }],
  };
});

export const sortCards = (items, sortOrder) => {
  if (sortOrder === 'a-z-title') {
    const sortList = [];
    const marketingCardList = [];

    items.forEach(item => {
      const selectedList = isMarketingCard(item) ? marketingCardList : sortList;
      selectedList.push(item);
    });

    sortList.sort((a, b) => {
      if (a.product?.productInformation?.title < b.product?.productInformation?.title) {
        return -1;
      }
      if (a.product?.productInformation?.title > b.product?.productInformation?.title) {
        return 1;
      }
      return 0;
    });

    marketingCardList.forEach(item => {
      const idx = items.indexOf(item);
      sortList.splice(idx, 0, item);
    });

    return sortList;
  }

  return items;
};
